import { render, staticRenderFns } from "./AgentIntro.vue?vue&type=template&id=a138c650&scoped=true"
import script from "./AgentIntro.vue?vue&type=script&lang=ts"
export * from "./AgentIntro.vue?vue&type=script&lang=ts"
import style0 from "./AgentIntro.vue?vue&type=style&index=0&id=a138c650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a138c650",
  null
  
)

export default component.exports